import type { GemxQlQueryResponse, GemxQlQueryVariables } from '~/core/gemxql/graphql';
import type { UseQueryOptions } from '@tanstack/react-query';

import { captureSentryError } from '~/exceptions/sentry';
import { appFetcher } from '~/api/utils/gatewayClient';
import { GemxQlDocument } from '~/core/gemxql/graphql';
import { useQuery } from '@tanstack/react-query';

interface UseGemxQlNamedQueryParams {
  name: string;
  variables: GemxQlQueryVariables;
}

export const useGemxQlNamedQuery = <TData = GemxQlQueryResponse, TError = unknown>(
  { name, variables }: UseGemxQlNamedQueryParams,
  options?: UseQueryOptions<GemxQlQueryResponse, TError, TData>,
) => {
  const document = GemxQlDocument.replace(/query\s+GemxQL\b/, `query ${name}`);

  return useQuery<GemxQlQueryResponse, TError, TData>(
    [name, variables],
    appFetcher<GemxQlQueryResponse, GemxQlQueryVariables>(document, variables),
    {
      retry: 0,
      ...options,
      onError: (error) => {
        captureSentryError(error, {
          source: 'useGemxQlNamedQuery',
          tags: { analytic: 'Analytic' },
          extra: { name, variables },
        });
        options?.onError?.(error);
      },
    },
  );
};

useGemxQlNamedQuery.getKey = (name: string, variables: GemxQlQueryVariables) => [name, variables];
